"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moreButton = _interopRequireDefault(require("../lib/more-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Cards =
/*#__PURE__*/
function (_Component) {
  _inherits(Cards, _Component);

  function Cards(props) {
    var _this;

    _classCallCheck(this, Cards);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cards).call(this, props));
    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(Cards, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(url, newTab) {
      if (newTab) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", null, this.state.data.map(function (card, index) {
        return card.type == "more" ? _react.default.createElement("div", {
          className: "card-container"
        }, _react.default.createElement("img", {
          src: card.image.fields.file.url
        }), _react.default.createElement("div", {
          className: "card-text-container"
        }, _react.default.createElement("div", {
          className: "card-title"
        }, card.title), _react.default.createElement("div", {
          className: "card-description"
        }, card.description)), _react.default.createElement("button", {
          className: "button button-transparent card-button-full-width",
          onClick: function onClick() {
            return _this2.handleClick(card.moreInfoLink, false);
          }
        }, "MORE INFO")) : card.type == "launch" ? _react.default.createElement("div", {
          className: "card-container"
        }, _react.default.createElement("img", {
          src: card.image.fields.file.url
        }), _react.default.createElement("div", {
          className: "card-text-container"
        }, _react.default.createElement("div", {
          className: "card-title"
        }, card.title), _react.default.createElement("div", {
          className: "card-description"
        }, card.description)), _react.default.createElement("button", {
          className: "button button-blue card-button-full-width",
          onClick: function onClick() {
            return _this2.handleClick(card.appLink, false);
          }
        }, _react.default.createElement("span", null, _react.default.createElement("i", {
          className: "fa fa-external-link",
          "aria-hidden": "true"
        }), " "), "LAUNCH")) : card.type == "launchmore" ? _react.default.createElement("div", {
          className: "card-container"
        }, _react.default.createElement("img", {
          src: card.image.fields.file.url
        }), _react.default.createElement("div", {
          className: "card-text-container"
        }, _react.default.createElement("div", {
          className: "card-title"
        }, card.title), _react.default.createElement("div", {
          className: "card-description"
        }, card.description)), _react.default.createElement("button", {
          className: "button button-blue card-button-part-width",
          onClick: function onClick() {
            return _this2.handleClick(card.appLink, false);
          }
        }, "LAUNCH"), _react.default.createElement("div", {
          className: "cards-more-button"
        }, _react.default.createElement(_moreButton.default, {
          size: "regular",
          isPrimary: false,
          title: ""
        }, _react.default.createElement("ul", null, _react.default.createElement("li", null, _react.default.createElement("a", {
          onClick: function onClick() {
            return _this2.handleClick(card.moreInfoLink, false);
          }
        }, _react.default.createElement("i", {
          className: "fa fa-external-link",
          "aria-hidden": "true"
        }), " More information")), _react.default.createElement("li", null, _react.default.createElement("a", {
          onClick: function onClick() {
            return _this2.handleClick(card.appLink, true);
          }
        }, _react.default.createElement("i", {
          className: "fa fa-external-link",
          "aria-hidden": "true"
        }), " Launch in a new tab")))))) : "";
      }));
    }
  }]);

  return Cards;
}(_react.Component);

var _default = Cards;
exports.default = _default;